module.exports = __webpack_public_path__ + "static/img/bg-pt.627e6855.png";